import React from "react";
import { Row, Col, Button, Dropdown } from "react-bootstrap";
import TicketsHeader from "../../../components/crm/tickets/TicketsHeader";
import TicketStats from "../../../components/crm/tickets/TicketStats";
/* =========================
   MAIN PAGE
========================= */

import { FaChevronDown } from "react-icons/fa";
const TicketListPage = () => {
  
  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }} >
<TicketsHeader  tittle="Ticket List" />
<TicketStats/>
      {/* HEADER */}
     <div className="card-tickets mb-3 p-3">
           <div className="d-flex justify-content-between flex-wrap">
             <h5>Ticket List</h5>
   
             <div className="d-flex gap-2 flex-wrap">
               <Dropdown>
                 <Dropdown.Toggle size="sm"   className="border brder-2" variant="light">
                   Priority
                 </Dropdown.Toggle>
                 <Dropdown.Menu>
                   <Dropdown.Item>High</Dropdown.Item>
                   <Dropdown.Item>Low</Dropdown.Item>
                 </Dropdown.Menu>
               </Dropdown>
   
               <Dropdown>
                 <Dropdown.Toggle  className="border brder-2" size="sm" variant="light">
                   Select Status
                 </Dropdown.Toggle>
                 <Dropdown.Menu>
                   <Dropdown.Item>Open</Dropdown.Item>
                   <Dropdown.Item>Closed</Dropdown.Item>
                 </Dropdown.Menu>
               </Dropdown>
   
               <Dropdown>
                 <Dropdown.Toggle  className="border brder-2" size="sm" variant="light">
                   Sort By : Last 7 Days
                 </Dropdown.Toggle>
                 <Dropdown.Menu>
                   <Dropdown.Item>Ascending</Dropdown.Item>
                   <Dropdown.Item>Descending</Dropdown.Item>
                 </Dropdown.Menu>
               </Dropdown>
             </div>
           </div>
         </div>

      <Row style={{ rowGap: "16px" }}>
        {/* LEFT */}
        <Col xl={9} md={8} sm={12}>
          <TicketCard
            title="Laptop Issue"
            code="Tic - 001"
            status="Open"
            priority="High"
            user="Edgar Hansel"
            img="/assets/img/profiles/avatar-03.jpg"
            color="#ef4444"
          />

          <TicketCard
            title="Payment Issue"
            code="Tic - 002"
            status="On Hold"
            priority="Low"
            user="Ann Lynch"
            img="/assets/img/profiles/avatar-01-1.jpg"
            color="#22c55e"
          />

          <TicketCard
            title="Bug Report"
            code="Tic - 003"
            status="Reopened"
            priority="Medium"
            user="Juan Hermann"
            img="/assets/img/profiles/avatar-06-1.jpg"
            color="#f59e0b"
          />

          <TicketCard
            title="Access Denied"
            code="Tic - 004"
            status="Open"
            priority="Low"
            user="Jessie Otero"
            img="/assets/img/profiles/avatar-05.jpg"
            color="#22c55e"
          />

          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Button
              style={{
                background: "#ff6b00",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
              }}
            >
              ⟳ Load More
            </Button>
          </div>
        </Col>

        {/* RIGHT */}
        <Col xl={3} md={4} sm={12}>
          <SidebarCard
            title="Ticket Categories"
            items={[
              ["Internet Issue", 0],
              ["Computer", 1],
              ["Redistribute", 0],
              ["Payment", 2],
              ["Complaint", 1],
            ]}
          />

          <SidebarAgents />
        </Col>
      </Row>
    </div>
  );
};

export default TicketListPage;

/* =========================
   FILTER BUTTON
========================= */
const FilterBtn = ({ text }) => (
  <button
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      padding: "6px 10px",
      borderRadius: "6px",
      fontSize: "13px",
    }}
  >
    {text}
  </button>
);

/* =========================
   TICKET CARD
========================= */
const TicketCard = ({
  title,
  code,
  status,
  priority,
  user,
  img,
  color,
}) => {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "5px",
        marginBottom: "16px",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span style={{ color: "#0ea5e9" }}>IT Support</span>

        <span
          style={{
            background: color,
            color: "#fff",
            padding: "3px 8px",
            borderRadius: "6px",
            fontSize: "11px",
          }}
        >
          ● {priority}
        </span>
      </div>

      {/* BODY */}
      <div style={{ padding: "16px" }}>
        <span
          style={{
            background: "#3b82f6",
            color: "#fff",
            padding: "3px 8px",
            borderRadius: "12px",
            fontSize: "11px",
          }}
        >
          {code}
        </span>

        <div style={{ marginTop: "8px" }}>
          <span style={{ fontWeight: "600" }}>{title}</span>

          <span
            style={{
              marginLeft: "8px",
              border: "1px solid #f43f5e",
              color: "#f43f5e",
              padding: "2px 6px",
              borderRadius: "6px",
              fontSize: "11px",
            }}
          >
            ● {status}
          </span>
        </div>

        <div
          style={{
            marginTop: "8px",
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            fontSize: "13px",
            color: "#6b7280",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={img}
              alt=""
              style={{
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                marginRight: "6px",
              }}
            />
            Assigned to <b style={{ marginLeft: "4px", color: "#111" }}>{user}</b>
          </div>

          <span>Updated 10 hours ago</span>
          <span>9 Comments</span>
        </div>
      </div>
    </div>
  );
};

/* =========================
   SIDEBAR CATEGORY CARD
========================= */
const SidebarCard = ({ title, items }) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      borderRadius: "5px",
      marginBottom: "16px",
    }}
  >
    <div
      style={{
        padding: "12px 16px",
        borderBottom: "1px solid #e5e7eb",
        fontWeight: "600",
      }}
    >
      {title}
    </div>

    {items.map((item, i) => (
      <div
        key={i}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: i !== items.length - 1 ? "1px solid #eee" : "none",
        }}
      >
        {item[0]}

        <span
          style={{
            background: "#111",
            color: "#fff",
            borderRadius: "50%",
            width: "22px",
            height: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "11px",
          }}
        >
          {item[1]}
        </span>
      </div>
    ))}
     <style>
          {
               `
               .card-tickets{
               border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
               
               }`
          }
      </style>
  </div>
);

/* =========================
   SIDEBAR AGENTS
========================= */
const SidebarAgents = () => {
  const agents = [
    ["Edgar Hansel", 0, "avatar-01-1.jpg"],
    ["Ann Lynch", 1, "avatar-02-1.jpg"],
    ["Juan Hermann", 0, "avatar-03.jpg"],
    ["Jessie Otero", 2, "avatar-04.jpg"],
  ];

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
          fontWeight: "600",
        }}
      >
        Support Agents
      </div>

      {agents.map((item, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: i !== agents.length - 1 ? "1px solid #eee" : "none",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={`/assets/img/profiles/${item[2]}`}
              alt=""
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                marginRight: "8px",
              }}
            />
            {item[0]}
          </div>

          <span
            style={{
              background: "#111",
              color: "#fff",
              borderRadius: "50%",
              width: "22px",
              height: "22px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "11px",
            }}
          >
            {item[1]}
          </span>
        </div>
      ))}
    </div>
  );
};